import { WebGLProbe } from '../../webgl';
import type { RuntimeEnv } from './types';

export const getBrowserRuntimeEnv = (): RuntimeEnv => {
  const touchSupported = 'ontouchstart' in window || 'ontouchstart' in document || window.navigator.maxTouchPoints > 0;

  return {
    document,
    window,
    isTouchSupported: touchSupported,
    WebGLProbe: new WebGLProbe(),
    dispose: () => {
      // no-op in browser runtime
    },
  };
};
